import { FixaAccordionItem } from "../../../wrappers/FixaAccordion/FixaAccordion";
import FilterAccordionCss from "../FilterAccordion/FilterAccordion.module.css";
import { FixaListViewItem } from "../../../wrappers/FixaListView/FixaListViewItem";
import { FixaListView } from "../../../wrappers/FixaListView/FixaListView";
import { CheckboxFilter, FilterValue } from "../../types/filter";

interface InputCheckboxOptionProps {
  filter: CheckboxFilter;
  filterValues: FilterValue[];
  openFilters: string[];
  onOpenChange: (isOpen: boolean) => void;
  setFilterValues: (filterValues: FilterValue[]) => void;
}

export const InputCheckboxOption = ({
  filter,
  filterValues,
  openFilters,
  onOpenChange,
  setFilterValues,
}: InputCheckboxOptionProps) => {
  const { title, id, dependsOnFilterId } = filter;
  const checked = filterValues.some((value) => value.filterId === id);

  const handleCheckboxChange = () => {
    const filterValuesWithoutThisFilter = filterValues.filter(
      (value) => value.filterId !== id
    );

    setFilterValues(
      checked
        ? filterValuesWithoutThisFilter
        : [
            ...filterValuesWithoutThisFilter,
            {
              filterId: id,
              value: true,
              dependsOnFilterId: dependsOnFilterId,
            },
          ]
    );
  };

  return (
    <FixaAccordionItem
      id={id}
      title={title}
      className={FilterAccordionCss["accordion-item-title"] ?? ""}
      open={openFilters.some((filterId) => filterId === id)}
      onTransitionEnd={(_event, isOpen) => {
        onOpenChange(isOpen);
      }}
    >
      <FixaListView id={id}>
        <FixaListViewItem
          inset
          control="checkbox"
          title={title}
          controlProps={{
            value: id,
            checked: checked,
          }}
          onChange={handleCheckboxChange}
        />
      </FixaListView>
    </FixaAccordionItem>
  );
};
